'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var loadLocale = exports.loadLocale = function loadLocale() {
  return localStorage.getItem('locale');
};

var saveLocale = exports.saveLocale = function saveLocale(locale) {
  localStorage.setItem('locale', locale);
};

var LocalStorageHandlers = exports.LocalStorageHandlers = {
  loadLocale: loadLocale,
  saveLocale: saveLocale
};